import * as React from 'react';
import { useAtomValue } from 'jotai';

import { JobExplorerSidebar } from './job-explorer-sidebar';
import { JobExplorerMap } from './job-explorer-map';
import { ListHeadTitle } from './job-explorer-content';
import { getToggleFullScreenAtom } from './job-explorer-map.atoms';
import { hasMapViewAtom } from './job-explorer-list.atoms';

interface IJobExplorerDesktopElementProps {
  ambassadorCode?: string;
}
export const JobExplorerDesktopElement: React.FunctionComponent<IJobExplorerDesktopElementProps> = ({
  ambassadorCode,
}) => {
  const hasMapView = useAtomValue(hasMapViewAtom);
  const toggleFullScreen = useAtomValue(getToggleFullScreenAtom);

  const jobExplorerMap = (
    <div className="relative" data-cy="job-explorer-map">
      <JobExplorerMap key="map-with-list" isDesktop />
    </div>
  );
  const listHeadTitle = <ListHeadTitle />;
  const explorerSidebar = <JobExplorerSidebar ambassadorCode={ambassadorCode} testId="explorer-sidebar-desktop" />;
  const mainEl =
    !toggleFullScreen && hasMapView ? (
      <div className="hidden flex-col gap-0 items-center relative lg:w-full lg:flex lg:flex-row lg:items-start max-w-full overflow-hidden">
        <div className="flex flex-col gap-4 min-w-[22rem] max-w-[22rem] pl-4 pr-2 pt-4 lg:gap-0">
          {listHeadTitle}
          <div>{explorerSidebar}</div>
        </div>
        <div className="flex flex-col gap-4 w-[calc(100vw-348px)] xl:max-w-[calc(100vw-348px)] xl:w-[calc(100vw-348px)] lg:max-w-[calc(100vw-348px)] pr-0">
          {jobExplorerMap}
        </div>
      </div>
    ) : !hasMapView ? (
      <div className="hidden lg:block transition duration-100 ease-in-out pt-2">
        <div className="flex gap-4 flex-col">
          <div className="flex gap-4 flex-row">{listHeadTitle}</div>
          {explorerSidebar}
        </div>
      </div>
    ) : (
      <div className="hidden lg:block">{jobExplorerMap}</div>
    );
  return (
    <div data-cy="job-explorer-save-research-desktop" className="bg-neutral-10">
      {mainEl}
    </div>
  );
};

export default JobExplorerDesktopElement;
